import React from "react"
import { observer } from "mobx-react-lite"
import { makeAutoObservable } from "mobx"

export class SearchWidgetContextState {
  isActive: boolean = false

  isSettingsShown: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setActive = (value: boolean) => {
    this.isActive = value
  }

  showSettings = (value: boolean) => {
    this.isSettingsShown = value
  }
}

export const SearchWidgetContext =
  React.createContext<SearchWidgetContextState | null>(null)

export const SearchWidgetProvider: React.FC<{
  value: SearchWidgetContextState
  children: React.ReactNode
}> = observer(({ value, children }) => {
  return (
    <SearchWidgetContext.Provider value={value}>
      {children}
    </SearchWidgetContext.Provider>
  )
})

export const useSearchWidget = () => {
  const context = React.useContext(SearchWidgetContext)
  if (!context) {
    throw new Error("useSearchWidget must be used within SearchWidgetProvider")
  }
  return context
}
